import './NoticeBanner.2fbd1df1bf84b809fe00e13798e578f5.css';
export default {"notice":"_notice_1pdy7_1","WARNING":"_WARNING_1pdy7_1","INFO":"_INFO_1pdy7_1","ERROR":"_ERROR_1pdy7_1","SUCCESS":"_SUCCESS_1pdy7_1"};